// DocumentSearchEmpty — zero-result state (CTSK-493 §3 item 6; design
// doc §3.6): “No documents match "<query>". Try fewer terms · Open full
// search”. The link is a real anchor (middle-click / copy work) that
// hands same-tab navigation to the app router.

import type { MouseEvent } from 'react';

export interface DocumentSearchEmptyProps {
  query: string;
  fullSearchHref: string;
  onNavigate: (path: string) => void;
}

export function DocumentSearchEmpty({ query, fullSearchHref, onNavigate }: DocumentSearchEmptyProps) {
  function go(e: MouseEvent<HTMLAnchorElement>) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    onNavigate(fullSearchHref);
  }
  return (
    <div className="doc-search__state" role="status" data-testid="document-search-empty">
      <p>
        No documents match <q>{query}</q>.
      </p>
      <p className="doc-search__hint">
        Try fewer terms, or{' '}
        <a href={fullSearchHref} onMouseDown={(e) => e.preventDefault()} onClick={go}>
          open full search
        </a>
        .
      </p>
    </div>
  );
}
